/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTriggeredActions} from '../api'

 export const useQueryGetTriggeredActions = createReactQueryHook('getTriggeredActions', getTriggeredActions)
